function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.00001 3.49975C5.06701 3.49975 3.50001 5.06676 3.50001 6.99975C3.50001 8.93275 5.06701 10.4998 7.00001 10.4998C8.93301 10.4998 10.5 8.93275 10.5 6.99975C10.5 5.06676 8.93301 3.49975 7.00001 3.49975ZM7.00002 8.5C6.1716 8.5 5.50002 7.82843 5.50002 7C5.50002 6.17157 6.1716 5.5 7.00002 5.5C7.82845 5.5 8.50002 6.17157 8.50002 7C8.50002 7.82843 7.82845 8.5 7.00002 8.5ZM15 -0.00012207H7.00002C3.13402 -0.000122013 1.52588e-05 3.13388 1.52588e-05 6.99988C1.52588e-05 10.8659 3.13402 13.9999 7.00002 13.9999H15C18.866 13.9999 22 10.8659 22 6.99988C22 3.13388 18.866 -0.000121971 15 -0.00012207ZM15 11.9998H7.00001C4.23858 11.9998 2.00001 9.76118 2.00001 6.99975C2.00001 4.23833 4.23858 1.99975 7.00001 1.99975H15C17.7614 1.99975 20 4.23833 20 6.99975C20 9.76118 17.7614 11.9998 15 11.9998Z",
  fill: "#FF6600"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.901 13.5V1.43H39.165L42.191 7.431H42.225L45.217 1.43H48.498V13.5H45.302V7.567H45.251L43.228 11.324H41.171L39.148 7.533H39.097V13.5H35.901Z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.2776 13.5V1.43H58.3016V4.303H53.4056V6.122H57.2306V8.876H53.4056V10.627H58.6586V13.5H50.2776Z",
  fill: "currentColor"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.0563 13.5V1.43H63.1333L67.4003 8.264L67.4343 8.247V1.43H70.6133V13.5H67.4343L63.2523 6.887H63.2183V13.5H60.0563Z",
  fill: "currentColor"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.9488 6.156L72.4418 1.43H75.3658L74.1248 6.156H71.9488Z",
  fill: "currentColor"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.2476 13.67C78.6836 13.67 77.0686 13.058 75.7766 11.732L77.6126 9.488C78.5646 10.457 79.6186 10.831 80.3666 10.831C81.1146 10.831 81.4036 10.423 81.4036 10.049C81.4036 9.573 81.1656 9.318 79.8736 8.893C78.0376 8.264 76.2016 7.38 76.2016 4.915C76.2016 2.858 77.9186 1.311 80.2306 1.26C81.8966 1.226 83.3756 1.872 84.4976 2.875L82.7126 5.17C81.6586 4.354 81.0126 4.082 80.4176 4.082C79.8396 4.082 79.5676 4.371 79.5676 4.796C79.5676 5.204 79.8226 5.527 81.0466 6.003C83.1886 6.819 84.8036 7.346 84.8036 9.675C84.8036 12.701 82.2706 13.67 80.2476 13.67Z",
  fill: "currentColor"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.9225 13.5V1.43H93.2545V10.627H97.9635V13.5H89.9225Z",
  fill: "currentColor"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.221 13.5V1.43H102.553V13.5H99.221Z",
  fill: "currentColor"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M107.935 13.5L103.515 1.43H107.034L109.346 8.876H109.38L111.709 1.43H115.177L110.774 13.5H107.935Z",
  fill: "currentColor"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M116.053 13.5V1.43H124.077V4.303H119.181V6.122H123.006V8.876H119.181V10.627H124.434V13.5H116.053Z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 125,
    height: 14,
    viewBox: "0 0 125 14",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default __webpack_public_path__ + "static/media/logo-secondary.6aae3b9f.svg";
export { SvgComponent as ReactComponent };